import { FormProvider } from "react-hook-form";
import { FaCircleArrowDown, FaFileInvoiceDollar, FaMoneyBill, FaPaperclip } from "react-icons/fa6";
import CustomButton from "shared/components/button/CustomButton";
import CustomModal from "shared/components/modal/CustomModal";
import { useCadastrarDespesaUnica } from "hooks/groupPay/useCadastrarDespesaUnicaGroupPay";
import { CustomAccordionItem } from "types/accordion/CustomAccordionItemType";
import { DespesaGroupPayDetalhada } from "types/response/groupPay/DespesaGroupPayDetalhadaResponse";
import AccordionDespesa from "./cadastrarDespesa/AccordionDespesa";
import SecaoDadosDespesaModalCadastrarDespesaUnicaGroupPay from "./SecaoDadosDespesaModalCadastrarDespesaUnicaGroupPay";
import SecaoRetencaoModalCadastrarDespesaGroupPay from "./SecaoRetencaoModalCadastrarDespesaGroupPay";
import SecaoBaixaContaPrincipal from "./SecaoBaixaContaPrincipal";
import InputMultiAnexos from "shared/components/input/InputMultiAnexos";

interface ModalCadastrarDespesaUnicaGroupPayProps {
  despesaDetalhada: DespesaGroupPayDetalhada;
  onCloseModal: () => void;
  showModal: boolean;
}

const ModalCadastrarDespesaUnicaGroupPay: React.FC<ModalCadastrarDespesaUnicaGroupPayProps> = (props) => {
  const {
    form,
    onSubmit,
    classesConta,
    adicionarClasseConta,
    removerClasseConta,
    valorBrutoTotal,
    valorTotalImpostos,
    handleCloseModal,
    retencoes,
    adicionarRetencao,
    removerRetencao,
  } = useCadastrarDespesaUnica({
    despesaGroupPay: props.despesaDetalhada,
    onClose: props.onCloseModal,
    showModal: props.showModal,
  });

  const renderContent = () => {
    const itensAccordion: CustomAccordionItem[] = [
      {
        key: "dados-despesa",
        titulo: "Dados da despesa",
        icon: <FaCircleArrowDown size={20} />,
        conteudo: (
          <SecaoDadosDespesaModalCadastrarDespesaUnicaGroupPay
            classesConta={classesConta}
            condominioId={props.despesaDetalhada.idCondominio}
            adicionarClasseConta={adicionarClasseConta}
            removerClasseConta={removerClasseConta}
            valorBrutoTotal={valorBrutoTotal}
          />
        ),
      },
      {
        key: "retencoes",
        titulo: "Retenções",
        icon: <FaMoneyBill size={20} />,
        conteudo: (
          <SecaoRetencaoModalCadastrarDespesaGroupPay
            retencoes={retencoes}
            adicionarRetencao={adicionarRetencao}
            removerRetencao={removerRetencao}
            somaValorBruto={valorBrutoTotal}
            valorTotalImpostos={valorTotalImpostos}
            condominioId={props.despesaDetalhada.idCondominio}
          />
        ),
      },
      {
        key: "anexo",
        titulo: "Anexos",
        icon: <FaPaperclip size={20} />,
        conteudo: (
          <InputMultiAnexos
            name="anexos"
            control={form.control}
            setValue={form.setValue}
            watch={form.watch}
            required={false}
            accept=".pdf,.doc,.xls,.png,.jpeg,.csv"
          />
        ),
      },
      {
        key: "baixar-despesa",
        titulo: `Baixa da conta principal`,
        icon: <FaFileInvoiceDollar size={20} />,
        conteudo: <SecaoBaixaContaPrincipal />,
      },
    ];

    return (
      <FormProvider {...form}>
        <AccordionDespesa keyItemAtivoPorPadrao="dados-despesa" itens={itensAccordion} permitirVariosItensAtivos />
      </FormProvider>
    );
  };

  return (
    <CustomModal
      key={"modal-cadastrar-despesa-unica-group-pay"}
      titulo="Incluir contas a pagar"
      size="xl"
      tipoModal="MODAL_LATERAL"
      bodyClassName="p-0"
      fecharModalAoClicarFora={!form.formState.isDirty}
      scrollable
      customFooter={
        <div>
          <CustomButton
            id="btn-cancelar"
            label="Cancelar"
            onClick={handleCloseModal}
            variant="danger-alt"
            className="me-3"
          />
          <CustomButton id="btn-salvar" label="Salvar" onClick={onSubmit} variant="primary" />
        </div>
      }
      onCloseModal={handleCloseModal}
      showModal={props.showModal}
    >
      <div className="p-4 pb-0">{renderContent()}</div>
    </CustomModal>
  );
};

export default ModalCadastrarDespesaUnicaGroupPay;
